import { createReducer } from 'typesafe-actions';

import { IBaseState } from '@/store/types/base.state';
import { TNavigationAction, NavigationActionTypes } from '@/store/types/navigation.types';

const initialState: IBaseState = {
  isLoading: false,
};

export const navigationReducer = createReducer<IBaseState, TNavigationAction>(initialState)
  .handleType(NavigationActionTypes.NAVIGATE, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))
  .handleType(NavigationActionTypes.NAVIGATE_SUCCESS, (state) => {
    return {
      ...state,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(NavigationActionTypes.NAVIGATE_FAIL, (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  });
